import React, { useEffect, useState } from 'react'
import InstallationAddDeviceView from './InstallationAddDeviceView'
import crmservices from '../../wsclient';
import { useTranslation } from 'react-i18next';
import LoadingComponent from '../../components/Loading';
import AlertComponent from '../../components/Alert';
import { Dialog, DialogContent, Grid } from '@mui/material';
import LinearBuffer from './LinearBuffer';
import { createCustomFieldObj, getCustomFieldByKey, sleep } from "../../utils/util";
import { httpBackOfficeUtil } from '../../wsclient/crmservices/httpBackOfficeUtil';
import { fieldSubscriptionItems } from 'final-form';
export default function InstallationAddDeviceController(props) {
    console.log('InstallationAddDeviceController props: ', props);
    const organisation_id = document._portalConfig.organisation_id;
    const { t } = useTranslation();
    const [activeStep, setActiveStep] = useState(props.activeStepAddDevice ? props.activeStepAddDevice : 0);
    const [message, setMessage] = useState();
    const [stepMessage, setStepMessage] = useState();
    const [showProcessing, setShowProcessing] = useState(false);
    const [showLoadingSubscription, setShowLoadingSubscription] = useState(true);
    const [showLoadingService, setShowLoadingService] = useState(false);
    const [showLoadingDevice, setShowLoadingDevice] = useState(true);
    const [showLoadingServiceDevice, setShowLoadingServiceDevice] = useState(false);
    const [subscriptions, setSubscriptions] = useState([]);
    const [devices, setDevices] = useState([]);
    const [services, setServices] = useState([]);
    const [serviceDevices, setServiceDevices] = useState([]);
    const [subscriptionSelected, setSubscriptionSelected] = useState();
    const [deviceSelected, setDeviceSelected] = useState([]);
    const [quantityService, setQuantityService] = useState(false);
    const [serviceSelected, setServiceSelected] = useState([]);
    const [serviceToReloadDevice, setServiceToReloadDevice] = useState(null);
    const [loadingState, setLoadingState] = useState(false);
    const [actionState, setActionState] = useState(false);

    const { orderDetail, activity } = props;
    const customerContact = orderDetail ? orderDetail.contact : null;
    const products = {};
    const additionalServiceCfg = document._portalConfig.additional_service;
    const [additionalService, seAdditionalService] = useState([]);
    const [additionalServicePrices, setAdditionalServicePrices] = useState([]);
    const productDependenciesCfg = document._portalConfig.product_dependencies;

    useEffect(() => {
        if (customerContact) {
            onLoadSubscription();
            getTotalProduct();
        }
    }, [customerContact])

    useEffect(() => {
        console.log("AAAAA subscriptionSelected:", subscriptionSelected);
        if (subscriptionSelected) {
            if (activeStep == 0) {
                onLoadAllowDevices();
            } else {
                onLoadServices();
            }
        }
    }, [subscriptionSelected])

    useEffect(() => {
        if (activeStep == 1 && subscriptionSelected) {
            onLoadServices();
        }
    }, [activeStep])


    const getTotalProduct = () => {
        let items = orderDetail.items ? orderDetail.items : [];
        const filterItems = items.filter(i => {
            return i.product.sku != "Installation Service"
        })
        let quantity = filterItems ? filterItems.length : 0;
        setQuantityService(quantity)
    }

    const onLoadSubscription = async () => {
        let _subscriptions = [];
        try {
            const result = await crmservices.subscriptions.getContactSubscriptions(customerContact.id);
            if (result.code == 'OK') {
                _subscriptions = result.data.content ? result.data.content : [];
            }
        } catch (ex) {
            console.log("AAAAAAAA onLoadSubscription:", ex);
        }
        console.log('onLoadSubscription _subscriptions:', _subscriptions);
        if (_subscriptions.length > 0) {
            setSubscriptionSelected(_subscriptions[0]);
            await loadAdditionalService(_subscriptions[0]);
        }
        setSubscriptions(_subscriptions)
        setShowLoadingSubscription(false);
    }

    const loadAdditionalService = async (subscription) => {
        const result = await crmservices.config.getProductBySku({ search_value: additionalServiceCfg });
        console.log('loadAdditionalService: ', result);
        if (result.code == "OK" && result.data && result.data.content && result.data.content.length > 0) {
          seAdditionalService(result.data.content[0]); 
          const resultProductPrice = await crmservices.config.getProductPrices(result.data.content[0].id);
          console.log('resultProductPrice: ', resultProductPrice);
          if(resultProductPrice.code == "OK" && resultProductPrice.data){
            setAdditionalServicePrices(resultProductPrice.data);
            // let aaa = getAdditionalServicePriceTerm(subscription, resultProductPrice.data);
          }
        }
    };
    
    const onLoadAllowDevices = async () => {
        let devices = [];
        try {
            let myUserId = httpBackOfficeUtil.getSession().sub;
            devices = await crmservices.subscriptions.loadInstallerDevices({organisation_id, installerId: myUserId})
        } catch (ex) {
            console.log("AAAAAAAA onLoadAllowDevices:", ex);
        }
        // setDevices(devices);
        let services = await onLoadServices(false);
        await setAvailableDevices(devices, services);
        setShowLoadingDevice(false);
    }

    const setAvailableDevices = async(devices, services) => {    
        console.log('setAvaiableDevices devices= ', devices);
        console.log('setAvaiableDevices services= ', services);

        if(services && services.length > 0 && devices && devices.length > 0){
            let devicesTobeAdded = [];

            let productDependenciesTobeChecked = await loadDependencyRules();
            console.log('productDependenciesTobeChecked: ', productDependenciesTobeChecked);
            if(productDependenciesTobeChecked && productDependenciesTobeChecked.length > 0){
                for (let j = 0; j < devices.length; j++) {
                    let productDevice = await onLoadProduct(devices[j].product.id);
                    for (let i = 0; i < services.length; i++) {
                        let service = services[i];
                        let productService = await onLoadProduct(service.product.id);
                        if(productService.classification != "EXPENSES_SERVICE"){
                            if(productDependenciesTobeChecked && productDevice && productService){
                                let isAvailable = await isAllowedDevice(productDependenciesTobeChecked, productService.type.name, productDevice.type.name);
                                if(isAvailable && !devicesTobeAdded.includes(devices[j]))
                                    devicesTobeAdded.push(devices[j]);          
                            } 
                        }         
                    }
                }
                setDevices(devicesTobeAdded);
            } else
                setDevices(devices);
        }   
    }

    const loadDependencyRules = async() => {
        if(productDependenciesCfg && productDependenciesCfg != ""){
          console.log('loadDependencyRules load from config');
          return productDependenciesCfg;
        } else {
          let productDependencies = await crmservices.config.loadProductDependencies();
          console.log('loadDependencyRules = ', productDependencies);
          if (productDependencies.code == "OK") {
            productDependencies = productDependencies.data.content;
          } 
          // console.log('productDependencies = ', productDependencies);
          let productDependenciesTobeChecked = [];
          for (let r = 0; r < productDependencies.length; r++) {
            let pd = {name: productDependencies[r].item_name};
            // console.log('pd = ', pd);
            let prodRule = await onLoadProductDependencyRule(productDependencies[r].id);
            // console.log('prodRule = ', prodRule);
            if(prodRule){
              let dependencies = [];
              for(let d = 0; d < prodRule.dependencies.length; d++){
                dependencies.push(prodRule.dependencies[d].item_name);            
              }
    
              pd.dependencies = dependencies;
            }
            productDependenciesTobeChecked.push(pd);
          }
    
          return productDependenciesTobeChecked;
        }
    }

    const checkIfValueExists = (list, value) => {
        return list.some(obj => obj.name === value);
    };

    const isAllowedDevice = async (dependencies, serviceType, deviceType) => {
        const exist = checkIfValueExists(dependencies, serviceType);

        if(!exist)
            return true;

        for(let i = 0; i < dependencies.length; i++){
            let dp = dependencies[i];
            if(dp.name == serviceType && dp.dependencies.includes(deviceType)){
                return true;
            }
        }

        return false;
    }

    const onLoadProduct = async (productId) => {
        let product = products[productId];
        if(product != null){
            return product;
        }
       
        let prd = {}
        try {
            let data = await crmservices.config.getProduct(productId)
            if (data.code == 'OK') {
                prd = data.data
            }
        } catch (ex) {
            console.log("onLoadProduct Exception:", ex);
        }
        products[productId] = prd;
        return prd;
    }

    const onLoadProductDependencyRule = async (prodDeRuleId) => {
        let prodDependRule = {}
        try {
          let data = await crmservices.config.getProductDependencyRule(prodDeRuleId)
          console.log(data);
          if (data.code == 'OK') {
            prodDependRule = data.data
          }
        } catch (ex) {
          console.log("onLoadTypeProductForService Exception:", ex);
        }
        return prodDependRule;
    }   

    const onLoadServices = async (withDevice = true) => {
        setShowLoadingService(true);
        let services = [];
        try {
            console.log('subscriptionSelected:', subscriptionSelected);
            console.log('customerContact:', customerContact);
            const result = await crmservices.subscriptions.getContactServices({ subscription_id: subscriptionSelected.id, contact_id: customerContact.id });
            if (result.code == 'OK') {
                services = result.data.content ? result.data.content : [];
            }
        } catch (ex) {
            console.log("AAAAAAAA onLoadServices:", ex);
        }
        let servicesWithDevices = [];
        if (services.length > 0) {
            for (let i = 0; i < services.length; i++) {
                let service = { ...services[i] };
                if(service.product && service.product.classification != "EXPENSES_SERVICE"){
                    if(additionalServiceCfg && service.product.name == additionalServiceCfg){
                      continue;
                    }
                
                    if(withDevice){
                        const devices = await onLoadDeviceForService(service.id);
                        const devicesTobeAdded = await loadAvailableDevicesByAService(devices, service);
                        service.devices = devicesTobeAdded;
                    }
                    
                    servicesWithDevices.push(service);
                }
            }
        }
        setServices(servicesWithDevices)
        setShowLoadingService(false);

        return servicesWithDevices;
    }

    const loadAvailableDevicesByAService = async(devices, service) => {    
        console.log('setAvaiableDevices devices= ', devices);
        console.log('setAvaiableDevices service= ', service);

        if(service && devices && devices.length > 0){
        let devicesTobeAdded = [];

        let productDependenciesTobeChecked = await loadDependencyRules();
        console.log('productDependenciesTobeChecked: ', productDependenciesTobeChecked);
        if(productDependenciesTobeChecked && productDependenciesTobeChecked.length > 0){
            for (let j = 0; j < devices.length; j++) {
            let productDevice = await onLoadProduct(devices[j].device.product.id);
            let productService = await onLoadProduct(service.product.id);
                if(productService.classification != "EXPENSES_SERVICE"){
                if(productDependenciesTobeChecked && productDevice && productService){
                    let isAvailable = await isAllowedDevice(productDependenciesTobeChecked, productService.type.name, productDevice.type.name)
                    if(isAvailable && !devicesTobeAdded.includes(devices[j].device))
                    devicesTobeAdded.push(devices[j]);          
                } 
                }  
            }
            return devicesTobeAdded;
        } else
            return devices;
        }   
    }
    
    const onLoadDeviceForService = async (serviceID) => {
        let devices = [];
        try {
            const result = await crmservices.subscriptions.getServiceDevices({ service_id: serviceID });
            console.log("onLoadDeviceForService result:", result);
            if (result.code == 'OK') {
                devices = result.data.content ? result.data.content : [];
            }
        } catch (ex) {
            console.log("AAAAAAAA onLoadServices:", ex);
        }
        return devices;
    }


    const onSelectSubscription = (sub) => {
        setSubscriptionSelected(sub);
    }

    const onSelectServiceRow = (service) => {
        let existing = serviceSelected.filter(s => {
            return s.service_id == service.id
        });
        if (existing && existing.length > 0) {
            let _serviceSelected = serviceSelected.map(s => {
                if (s.service_id == service.id) {
                    s.is_active = true;
                } else {
                    s.is_active = false;
                }
                return s;
            });
            setServiceSelected(_serviceSelected);
        } else {
            let _serviceSelected = serviceSelected.map(s => {
                return { ...s, is_active: false }
            })
            let _newSelected = {
                service_name: service.product.name,
                service_id: service.id,
                device_id: null,
                device_serial_number: null,
                devices: [],
                is_active: true,
                is_checked: false
            }
            _serviceSelected.push(_newSelected);
            console.log("_serviceSelected:", _serviceSelected);
            setServiceSelected(_serviceSelected);
            if (service.id != serviceToReloadDevice) {
                setServiceDevices([]);
                setServiceToReloadDevice(service.id);
            }
        }
    }
    const onSelectService = (service) => {
        let _newSelected = {};
        let existing = serviceSelected.filter(s => {
            return s.service_id == service.id
        });
        console.log('xxxxxx existing:', existing);
        if (existing && existing.length > 0) {
            let _serviceSelectedFilter = serviceSelected.filter(s => {
                return s.service_id != service.id
            })
            let _serviceSelected = _serviceSelectedFilter.map(s => {
                return { ...s, is_active: false }
            });
            setServiceDevices([]);
            setServiceSelected(_serviceSelected);
        } else {
            let _serviceSelected = serviceSelected.map(s => {
                return { ...s, is_active: false }
            })
            _newSelected = {
                service_name: service.product.name,
                service_id: service.id,
                device_id: null,
                device_serial_number: null,
                devices: [],
                is_active: true,
                is_checked: true
            }
            _serviceSelected.push(_newSelected);
            console.log("_serviceSelected:", _serviceSelected);
            setServiceSelected(_serviceSelected);
            if (service.id != serviceToReloadDevice) {
                setServiceDevices([]);
                setServiceToReloadDevice(service.id);
            }
        }
    }


    const onSelectDeviceService = (service, device, isSelected) => {
        let _servicesSelected = [...serviceSelected];
        let existing = _servicesSelected.filter(s => {
            return s.service_id == service.id
        });
        console.log("existing:", existing);
        if (existing && existing.length > 0) {
            _servicesSelected = _servicesSelected.map(s => {
                if (s.service_id == service.id) {
                    let devices = [...s.devices];
                    console.log("devices:", devices);
                    console.log("isSelected:", isSelected);
                    if (isSelected) {
                        devices = devices.filter(d => {
                            return d.device_id != device.id;
                        })
                    } else {
                        devices.push({
                            device_id: device.id,
                            device_serial_number: device.serial_number
                        })
                    }
                    s.devices = devices;
                }
                return s;
            })
            setServiceSelected(_servicesSelected);
        } else {
            let devices = [{
                device_id: device.id,
                device_serial_number: device.serial_number
            }]
            let newObj = {
                service_id: service.id,
                devices: devices,
                service_name: service.product.name,
            }
            let _serviceSelected = [...serviceSelected];
            _serviceSelected.push(newObj);
            setServiceSelected(_serviceSelected);
        }
    }

    // const onSelectDevice = (device, isSelected) => {
    //     if (deviceSelected.length >= quantityService && !isSelected) {
    //         return;
    //     } else {
    //         let _devices = [...deviceSelected];
    //         if (_devices.length == 0) {
    //             _devices.push(device);
    //         } else {
    //             let existing = _devices.filter(d => {
    //                 return d.id == device.id
    //             })
    //             if (existing && existing.length > 0) {
    //                 _devices = _devices.filter(d => {
    //                     return d.id != device.id
    //                 })
    //             } else {
    //                 _devices.push(device);
    //             }
    //         }
    //         setDeviceSelected(_devices);
    //     }
    // }

    const onSelectDevice = (undefined, device, isSelected) => {
        // let _devices = [];
        // _devices.push(device);
        // setDeviceSelected(_devices);

        ///
        let _deviceSelected = [...deviceSelected];
        if (isSelected) {
            var index = _deviceSelected.indexOf(device);
            _deviceSelected.splice(index, 1);
        } else
            _deviceSelected.push(device);

        setDeviceSelected(_deviceSelected);
    }

    const onSubmitStepAddDevice = async () => {
        setStepMessage(null);
        setActionState(null);
        setShowProcessing(true);
        try {
            let count = 0;
            let actionId = null;
            
            let devicesSerialNumbers = "";
            let devicesIds = "";
            for (let i = 0; i < deviceSelected.length; i++) {
                const result = await crmservices.subscriptions.addSubscriptionDevices({
                    subscription_id: subscriptionSelected.id,
                    device_id: deviceSelected[i].id
                })
                if (result.code == 'OK') {
                    actionId = result.data.id;
                    count++;  
                    devicesSerialNumbers += deviceSelected[i].serial_number + ",";
                    devicesIds += deviceSelected[i].id + ",";
                } else {
                    let message = t('ADD_DEVICE_FAILED') + "(Serial Number: " + deviceSelected[i].serial_number + ")"
                    if (result.code == 'CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION') {
                        message = t('ADD_DEVICE_CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION')
                    }
                    setStepMessage(message);
                    break;
                }
            }
  
            if (count == deviceSelected.length) {
                setShowProcessing(false);
                setLoadingState(true);
                const state = await checkSubscriptionExecuted(actionId)
                console.log("AAAA state:", state);
                if (state === "EXECUTED") {
                    // await updateOrderCustomFields('adding_device');
                    let custom_fields = orderDetail.custom_fields;
                    custom_fields = createCustomFieldObj(custom_fields, "adding_device", "1");
                    custom_fields = createCustomFieldObj(custom_fields, "serial_device", devicesSerialNumbers);
                    try {
                        await crmservices.orders.updateOrder({ custom_fields: custom_fields, order_id: orderDetail.id });
                    } catch (ex) {
                        console.log("updateOrderCustomFields Exception:", ex);
                    }
      
                    setActiveStep(activeStep + 1);
                } else {
                    setStepMessage(t('ACTION_REJECTED'));
                }
                setLoadingState(false);
                setActionState(state);
            }
        } catch (ex) {
            showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
        }
        setShowProcessing(false);
    }

    const updateOrderCustomFields = async (key, isUpdateAgainAddingDevice) => {
        try {
            const order = await crmservices.orders.getOrderDetail(orderDetail.id);
            if (order && order.code == 'OK') {
                let custom_fields = order.data.custom_fields;
                
                let filterCustomFields = custom_fields.filter(c => {
                    return c.key != key
                })
                filterCustomFields.push({
                    key: key,
                    value: "1"
                })
                if (isUpdateAgainAddingDevice) {
                    filterCustomFields = filterCustomFields.filter(c => {
                        return c.key != 'adding_device'
                    });
                    filterCustomFields.push({
                        key: 'adding_device',
                        value: "1"
                    })
                }
                // console.log("filterCustomFields:", filterCustomFields);
                await crmservices.orders.updateOrder({ custom_fields: filterCustomFields, order_id: orderDetail.id });
            }
        } catch (ex) {
            console.log("updateOrderCustomFields Exception:", ex);
        }
    }

    const onSubmitStepEnableService = async () => {
        console.log("onSubmitStepEnableService serviceSelected:", serviceSelected);
        console.log("onSubmitStepEnableService subscriptionSelected:", subscriptionSelected);
        let payload = createRequestToEnableService();
        console.log("onSubmitStepEnableService payload:  ", payload);
        
        if (payload.length == 0) {
            setStepMessage('Please select services and devices!');
        } else {
            setStepMessage(null);
            setActionState(null);
            setShowProcessing(true);
            try {
                let count = 0;
                for (let i = 0; i < payload.length; i++) {
                    const enableDeviceRsl = await crmservices.subscriptions.enableDevices(payload[i]);
                    console.log("enableDevices result", enableDeviceRsl);
                    if (enableDeviceRsl.code == 'OK') {
                        await sleep(3000);
                        let state = await getSubscriptionActionState(enableDeviceRsl.data.id);
                        if (state === "EXECUTED") {
                            count++;

                            if(subscriptionSelected && subscriptionSelected.state == 'ACTIVE'){
                                console.log("enableDevices service to be started");
                                let activateServiceRsl = await activateServiceById(payload[i].service_id);
                                console.log("onSubmitStepEnableService activateServiceRsl: ", activateServiceRsl);
                                if(activateServiceRsl && activateServiceRsl.code != 'OK'){
                                    setStepMessage((activateServiceRsl && activateServiceRsl.data && activateServiceRsl.data.message) 
                                        ? activateServiceRsl.data.message : t('START_SERVICE_FAILURE')); 
                                }
                            }
                        } else {
                            let message = t('ACTION_REJECTED') + "  (" + payload[i].service_name + ")";
                            
                            let apiResponsedMes = (state && state.data && state.data.message) 
                                ? ( " " + state.data.message) : "";
                            
                            setStepMessage(message + apiResponsedMes);
                            break;
                        }
                    } else {
                        let message = t('ENABLE_DEVICE_FAILED') + "(" + payload[i].service_name + ")";

                        let apiResponsedMes = (enableDeviceRsl && enableDeviceRsl.data && enableDeviceRsl.data.message) 
                                ? ( " " + enableDeviceRsl.data.message) : "";
                            
                        setStepMessage(message + apiResponsedMes);

                        setStepMessage(message);
                        break;
                    }
                }
                if (count == payload.length) {
                    await updateOrderCustomFields('enable_devices', true);
                    
                    if(subscriptionSelected && subscriptionSelected.state != 'ACTIVE'){
                        const activateSubscriptionRsl = await crmservices.subscriptions.activateSubscription({
                            subscription_id: subscriptionSelected.id
                        })

                        console.log("onSubmitStepEnableService activateSubscriptionRsl:  ", activateSubscriptionRsl);

                        if (activateSubscriptionRsl.code == 'OK') {
                            props.onClose(true);
                        } else {
                            setStepMessage((activateSubscriptionRsl && activateSubscriptionRsl.data && activateSubscriptionRsl.data.message) 
                                            ? activateSubscriptionRsl.data.message : t('CANNOT_ACTIVATE_SUBSCRIPTION'));  
                        }
                    } else
                        props.onClose(true);
                }
            } catch (ex) {
                showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
            }
            setShowProcessing(false);
        }
    }

    const addAdditionalService = async() => {
        console.log("addAdditionalService services:  ", services);
        const subDevices = await crmservices.subscriptions.getSubscriptionDevices({
            subscription_id: subscriptionSelected.id
        });
        console.log('addAdditionalService subDevices = ', subDevices);
        let addresses = [];
        if (subDevices.code == "OK" && subDevices.data && subDevices.data.content.length > 0) {
            for(let i = 0; i < subDevices.data.content.length; i++){
                let sd = subDevices.data.content[i];
                let device =  await crmservices.subscriptions.getDeviceById(sd.device.id);
                // console.log('addAdditionalService device: ', device);
                if(device && device.code == 'OK' && device.data 
                    && device.data.custom_fields && device.data.custom_fields.length > 0){
                    for(let j = 0; j < device.data.custom_fields.length; j++){
                        let customField = device.data.custom_fields[j];
                        if(customField.key == 'customer_address'){
                            addresses.push(customField.value);
                        }
                    }
                }
            }
        }
        console.log('addAdditionalService device address custom field: ', addresses);
        let addressesRemoveDuplicated = removeDuplicates(addresses);
        console.log('addAdditionalService device addressesRemoveDuplicated: ', addressesRemoveDuplicated);

        let addAdditionalServiceQty = 0;
        let addAdditionalServiceId = 0;
        if(services && services.length > 0){
            for(let s = 0; s < services.length; s++){
                let srv = services[s];
                if(srv.product.name == additionalServiceCfg){
                    addAdditionalServiceQty = (srv.terms && srv.terms.quantity) ? srv.terms.quantity : 0;
                    addAdditionalServiceId = srv.id;
                }
            }
        }

        console.log('addAdditionalService addresses = ', addresses);
        console.log('addAdditionalService deviceSelected = ', deviceSelected);
        console.log('addAdditionalService activity = ', activity);
        console.log('addAdditionalService addAdditionalServiceQty = ', addAdditionalServiceQty);
        console.log('addAdditionalService addAdditionalServiceId = ', addAdditionalServiceId);
        let existAddress = false;
        let addressId = getActivityAddressId();
        console.log('addAdditionalService addressId = ', addressId);   
        if(addressesRemoveDuplicated && addressesRemoveDuplicated.length > 0 && addressesRemoveDuplicated.includes(addressId)){
            existAddress = true;
        }

        console.log('addAdditionalService serviceSelected = ', serviceSelected);
        let requireStartAdditionalService = false;
        let selectedDevices = [];
        if(serviceSelected && serviceSelected.length > 0){
            for(let s = 0; s < serviceSelected.length; s++){
                let sd = serviceSelected[s];
                if(sd.devices && sd.devices.length > 0){
                    for(let d = 0; d < sd.devices.length; d++){
                        selectedDevices.push(sd.devices[d].device_id);
                    }
                }
            }
            console.log('selectedDevices: ', selectedDevices);
            let selectedDeviceSerialsRemoveDuplicated = removeDuplicates(selectedDevices);
            console.log('selectedDeviceSerialsRemoveDuplicated: ', selectedDeviceSerialsRemoveDuplicated);
            
            if(selectedDeviceSerialsRemoveDuplicated.length > 0){
                if(existAddress){
                    if(addAdditionalServiceQty > 0){//exist additional service on sub
                        addAdditionalServiceQty = addAdditionalServiceQty + selectedDeviceSerialsRemoveDuplicated.length;
                        const updateServiceRsl = await crmservices.subscriptions.updateService({ action: "CHANGE", quantity: addAdditionalServiceQty }, addAdditionalServiceId);
                        console.log('updateServiceRsl: ', updateServiceRsl);
                        if(updateServiceRsl.code != "OK")
                            setMessage((updateServiceRsl && updateServiceRsl.data && updateServiceRsl.data.message) 
                                            ? updateServiceRsl.data.message : t('UPDATE_SERVICE_FAILURE'));  
                    } else {
                        let addServiceRsl = await addSubscriptionService(selectedDeviceSerialsRemoveDuplicated.length);
                        if (addServiceRsl.code == "OK") {
                            requireStartAdditionalService = true;
                            // let startServiceRsl = await activateAdditionalServiceIfExist();
                            // console.log('startServiceRsl: ', startServiceRsl);
                            // if(startServiceRsl && startServiceRsl.code != "OK")
                            //     setMessage((startServiceRsl.data && startServiceRsl.data.message) 
                            //                 ? startServiceRsl.data.message : t('START_SERVICE_FAILURE'));  
                        } else {
                            setMessage((addServiceRsl && addServiceRsl.data && addServiceRsl.data.message) 
                                            ? addServiceRsl.data.message : t('ADD_ADDITIONALSERVICE_FAILURE'));  
                        }
                    }
                } else {
                    if(selectedDeviceSerialsRemoveDuplicated.length > 1){
                        if(addAdditionalServiceQty > 0){
                            addAdditionalServiceQty = addAdditionalServiceQty + selectedDeviceSerialsRemoveDuplicated.length - 1;
                            const updateServiceRsl = await crmservices.subscriptions.updateService({ action: "CHANGE", quantity: addAdditionalServiceQty }, addAdditionalServiceId);
                            console.log('updateServiceRsl: ', updateServiceRsl);
                            if(updateServiceRsl.code != "OK")
                                setMessage((updateServiceRsl && updateServiceRsl.data && updateServiceRsl.data.message) 
                                            ? updateServiceRsl.data.message : t('UPDATE_SERVICE_FAILURE'));  
                        } else {
                            let addServiceRsl = await addSubscriptionService(selectedDeviceSerialsRemoveDuplicated.length - 1);
                            if (addServiceRsl.code == "OK") {
                                requireStartAdditionalService = true;
                                let startServiceRsl = await activateAdditionalServiceIfExist();
                                if(startServiceRsl && startServiceRsl.code != "OK")
                                    setMessage(t("START_SERVICE_FAILURE"));
                                    setMessage((startServiceRsl.data && startServiceRsl.data.message) 
                                            ? startServiceRsl.data.message : t('START_SERVICE_FAILURE'));  
                            } else {
                                setMessage((addServiceRsl && addServiceRsl.data && addServiceRsl.data.message) 
                                            ? addServiceRsl.data.message : t('ADD_ADDITIONALSERVICE_FAILURE'));  
                            }
                        }  
                    } 
                }

                for(let d = 0; d < selectedDeviceSerialsRemoveDuplicated.length; d++){
                    await populateAddressIdToDeviceCustomFields(selectedDeviceSerialsRemoveDuplicated[d]);
                }
            }      
        }

        return requireStartAdditionalService;
    }
    
    const removeDuplicates = (arr) => {
        const uniqueArray = [...new Set(arr)];
        return uniqueArray;
    }

    const addSubscriptionService = async(qty) => {
        let services = [];
        let additionalServicePriceTermId = getAdditionalServicePriceTerm(subscriptionSelected, additionalServicePrices);
        console.log('additionalServicePriceTermId = ', additionalServicePriceTermId);
        if(additionalServicePriceTermId == null)
            setMessage('Price term for Additional service is required');    

        let srv = {
            product_id: additionalService.id,
            price_terms_id: additionalServicePriceTermId,
            quantity: qty
        }

        services.push(srv);

        let payload = {
        services: services
        };
        console.log('addSubscriptionService payload = ', payload);
        const result = await crmservices.subscriptions.addSubscriptionService({
        subscription_id: subscriptionSelected.id,
        reqBody: payload
        });
        console.log('addSubscriptionService result = ', result);
        return result;
    };
    
    const getAdditionalServicePriceTerm = (subscription, prices) => {
        console.log("getAdditionalServicePriceTerm subscription:", subscription);
        console.log("getAdditionalServicePriceTerm additionalServicePrices:", prices);
        if(subscription && prices && prices.length > 0){
            for(let i = 0; i < prices.length; i++){
                if(subscription.terms && subscription.terms.billing_period
                    && subscription.terms.billing_period.duration
                    && subscription.terms.billing_period.uot
                    && prices[i].price_terms && prices[i].price_terms.billing_period
                    && prices[i].price_terms.billing_period.duration
                    && prices[i].price_terms.billing_period.uot
                    && subscription.terms.billing_period.duration == prices[i].price_terms.billing_period.duration
                    && subscription.terms.billing_period.uot == prices[i].price_terms.billing_period.uot
                    && prices[i].prices.length > 0){
                    return prices[i].prices[0].id;
                }
            }

            //no any case matches to the sub billing model so get a default config
            if(prices[0].prices.length > 0)
                return prices[0].prices[0].id;
        }

        return null;
    };

    const activateAdditionalServiceIfExist = async() => {
        const serviceRsl = await crmservices.subscriptions.getContactServices({
          subscription_id: subscriptionSelected.id,
          contact_id: customerContact.id,
        });
        console.log("activateService serviceRsl:", serviceRsl);
        if (serviceRsl.code == "OK") {
          const lsSerivces = serviceRsl.data.content ? serviceRsl.data.content : [];
    
          if(lsSerivces && lsSerivces.length > 0){
            for(let i = 0; i < lsSerivces.length; i++){
              if(lsSerivces[i].product.id == additionalService.id){
                const activateServiceRsl = await crmservices.subscriptions.activateService(lsSerivces[i].id);
                console.log('activateServiceRsl = ', activateServiceRsl);
                return activateServiceRsl;
              }
            }
          }
        }
    }

    const getActivityAddressId = () => {
        let addressId = null;
        if(activity){
          if(activity.address && activity.address.id){
            addressId = activity.address.id;
            console.log('populateAddressIdToDeviceCustomFields activity addressId= ', addressId);
          } else if(activity.contact && activity.contact.addresses && activity.contact.addresses.length > 0){
            addressId = activity.contact.addresses[0].id;
            console.log('populateAddressIdToDeviceCustomFields contact addressId= ', addressId);
          }
        }
    
        return addressId;
    }
    const createRequestToEnableService = () => {
        let payload = [];
        serviceSelected.forEach(element => {
            if (element.devices && element.devices.length > 0) {
                payload.push(element);
            }
        });
        return payload;
    }

    const activateServiceById = async(serviceId) => {
        console.log('activateServiceById serviceId = ', serviceId);
        console.log('activateServiceById services = ', services);
        if(services && services.length > 0 && serviceId){
            for(const srv of services){
                if(srv.id == serviceId && srv.state != "EFFECTIVE"){
                    let activateServiceRsl = await crmservices.subscriptions.activateService(serviceId);
                    console.log('activateServiceById activateServiceRsl = ', activateServiceRsl);
                    return activateServiceRsl;
                }
            }
        }    
    }

    const checkSubscriptionExecuted = async (actionId) => {
        let attempts = 3;
        let currentState = "PENDING_VERIFICATION";
        while (currentState == "PENDING_VERIFICATION" && attempts > 0) {
            currentState = await getSubscriptionActionState(actionId)
            if (attempts != 3) await sleep(3000); //delay 3s after first attempt
            attempts--;
        }
        return currentState
    }



    // get state to use in updateActivityIfExecuted function
    const getSubscriptionActionState = async (actionId) => {
        let state = null;
        try {
            const result = await crmservices.subscriptions.getSubscriptionAction({
                action_id: actionId
            });
            if (result.code === 'OK') {
                state = result.data.state;
                console.log("SubscriptionActionState: ", state);
            }
        } catch (error) {
            console.log("get updatingState error:", error);
            state = 'EXCEPTION'
        }
        return state
    }

    const showMessage = ({ status, title, message, otherMessage, callBackFn }) => {
        setShowProcessing(false);
        setMessage({ show: status, title: title, content: message, otherMessage, callBackFn: callBackFn ? callBackFn : () => setMessage({}) });
    }

    // update activity custom field
    const getActivity = async () => {
        if(orderDetail && customerContact){
            try {
                const listActivitiesRsl = await crmservices.activities.listActivityByCustomerAndOrder({
                    order_id: orderDetail.id,
                    contact_id: customerContact.id
                });
                console.log("updateActivityCustomFields listActivitiesRsl: ", listActivitiesRsl);
                if (listActivitiesRsl.code === 'OK') {
                    if(listActivitiesRsl.data && listActivitiesRsl.data.content && listActivitiesRsl.data.content.length > 0){
                        let act = listActivitiesRsl.data.content[0];
                        const getActivityRsl = await crmservices.activities.getActivity(act.id);
                        console.log('getActivity, getActivityDetail = ', getActivityRsl);
                        if (getActivityRsl.code == 'OK') {
                            return getActivityRsl.data;
                        }
                    }
                }
            } catch (error) {
                console.log("getActivity Exception:", error);
            }
        }
        
        return null;
    }

    const onUpdateActivityDeviceCustomFields = async (_activity, deviceSerial) => {
        console.log('onUpdateActivityDeviceCustomFields _activity = ', _activity);
        console.log('onUpdateActivityDeviceCustomFields deviceSerial = ', deviceSerial);
        if(deviceSerial){
            let custom_fields = _activity.custom_fields ? _activity.custom_fields : [];
            let _deviceAddedExist = getCustomFieldByKey(custom_fields, "device_added");
            if(_deviceAddedExist){
                deviceSerial = _deviceAddedExist + ',' + deviceSerial;                    
            }

            custom_fields = createCustomFieldObj(custom_fields, "device_added", deviceSerial);

            console.log('custom fields tobe updated= ', custom_fields);        
            try {
                const result = await crmservices.activities.updateActivity({ activity_id: _activity.id
                    , custom_fields: custom_fields});

                console.log('onUpdateActivityDeviceCustomFields = ', result);        
                if (result.code == 'OK') {
                    // onLoadActivities(paging.page, paging.size);
                    // showMessage({ status: true, message: t('UPDATE_ACTIVITY_SUCCESS') })
                } else {
                    showMessage({ status: true, message: (result.data && result.data.message) ? result.data.message : t('UPDATE_ACTIVITY_FAIL') })
                }
                    
            } catch (ex) {
                console.log("onUpdateActivityDeviceCustomFields ex:", ex);
                showMessage({ status: true, message: t('EXCEPTION_PROCESS') })
            } 
        }
    }

    // populate activity address id to devices custom field
    //TODOV: test again when release deliver the change to return address_id in activity
    const populateAddressIdToDeviceCustomFields = async (_activity, deviceId) => {
        console.log('populateAddressIdToDeviceCustomFields _activity = ', _activity);
        console.log('populateAddressIdToDeviceCustomFields deviceId = ', deviceId);
        if(deviceId && _activity && _activity.address && _activity.address.id){
            let device =  await crmservices.subscriptions.getDeviceById(deviceId);
            console.log('populateAddressIdToDeviceCustomFields device: ', device);
            if(device && device.code == 'OK' && device.data){
                let custom_fields = device.custom_fields ? device.custom_fields : [];

                custom_fields = createCustomFieldObj(custom_fields, "customer_address", _activity.address.id);
                await crmservices.subscriptions.updateDevice({ custom_fields: custom_fields }, device.id);
            }
        }
    }

    return (
        <>
            <InstallationAddDeviceView
                isOpen={props.isOpen}
                activeStep={activeStep}
                activity={activity}
                orderDetail={orderDetail}
                onClose={props.onClose}
                showLoadingSubscription={showLoadingSubscription}
                showLoadingDevice={showLoadingDevice}
                showLoadingService={showLoadingService}
                showLoadingServiceDevice={showLoadingServiceDevice}
                subscriptions={subscriptions}
                devices={devices}
                services={services}
                serviceDevices={serviceDevices}
                subscriptionSelected={subscriptionSelected}
                deviceSelected={deviceSelected}
                quantityPG={quantityService}
                message={message}
                stepMessage={stepMessage}
                serviceSelected={serviceSelected}
                loadingState={loadingState}
                actionState={actionState}
                onCancelAddDevice={props.onClose}
                onSelectSubscription={onSelectSubscription}
                onSelectDevice={onSelectDevice}
                onSelectService={onSelectService}
                onSelectDeviceService={onSelectDeviceService}
                onSubmitAddDevice={onSubmitStepAddDevice}
                onSubmitEnableService={onSubmitStepEnableService}
                onSelectServiceRow={onSelectServiceRow}
            />
            {showProcessing && <LoadingComponent showLoading={showProcessing} />}
            {message && message.show && <AlertComponent
                isOpen={message.show}
                message={message.content}
                otherMessage={message.otherMessage ? message.otherMessage : null}
                onClose={message.callBackFn}
            />}
            {loadingState &&
                <Dialog open={loadingState} sx={{ '& .MuiDialog-paper': { padding: '0px 0px' } }}>
                    <LinearBuffer status={actionState} />
                </Dialog>}
        </>
    )
}